import React from 'react';
import { motion } from 'framer-motion';
import { aboutData } from '../data/about';
import { useLanguage } from '../i18n';
import { localize } from '../i18n/localize';
import './ExperienceSection.css';

const ExperienceSection = () => {
  const { t, language } = useLanguage();

  return (
    <section id="experience" className="exp-section">
      <div className="container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.4 }}
        >
          <h2>{t('experience.title')}</h2>
          <div className="section-divider"></div>
        </motion.div>

        <div className="exp-grid">

          {/* ===== FORMAÇÃO ===== */}
          <motion.div
            className="exp-col"
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: 0.1 }}
          >
            <div className="exp-col-header">
              <span className="exp-col-icon">🎓</span>
              <h3>{t('experience.education')}</h3>
            </div>

            <div className="edu-timeline">
              {aboutData.education.map((edu) => (
                <div className="edu-item" key={edu.id}>
                  <div className="edu-dot" />
                  <div className="edu-body">
                    <h4>{localize(edu, 'degree', language)}</h4>
                    <p className="edu-inst">{edu.institution}</p>
                    <p className="edu-period">{localize(edu, 'period', language)}</p>
                    {edu.description && (
                      <p className="edu-desc">{localize(edu, 'description', language)}</p>
                    )}
                  </div>
                </div>
              ))}
            </div>

            {/* ===== ESPECIALIZAÇÕES ===== */}
            {aboutData.specializations && aboutData.specializations.length > 0 && (
              <div className="spec-section">
                <div className="exp-col-header" style={{ marginTop: '1.5rem' }}>
                  <span className="exp-col-icon">🏆</span>
                  <h3>{t('experience.specializations')}</h3>
                </div>
                <div className="spec-grid">
                  {aboutData.specializations.map((spec) => (
                    <motion.div
                      className="spec-card"
                      key={spec.id}
                      initial={{ opacity: 0, y: 10 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true }}
                      transition={{ duration: 0.3, delay: spec.id * 0.08 }}
                      whileHover={{ y: -3 }}
                    >
                      <span className="spec-icon">{spec.icon}</span>
                      <h4 className="spec-title">{localize(spec, 'title', language)}</h4>
                      <p className="spec-inst">{spec.institution}</p>
                      <p className="spec-desc">{localize(spec, 'description', language)}</p>
                    </motion.div>
                  ))}
                </div>
              </div>
            )}

          </motion.div>

          {/* ===== EXPERIÊNCIA ===== */}
          <motion.div
            className="exp-col"
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: 0.15 }}
          >
            <div className="exp-col-header">
              <span className="exp-col-icon">💼</span>
              <h3>{t('experience.professional')}</h3>
            </div>

            <div className="job-timeline">
              {aboutData.experiences.map((exp, index) => (
                <div
                  className={`job-item${index === 0 ? ' job-current' : ''}`}
                  key={exp.id}
                >
                  <div className="job-dot" />
                  <div className="job-body">
                    <div className="job-head">
                      <h4>{localize(exp, 'title', language)}</h4>
                      {index === 0 && (
                        <span className="job-badge">{t('experience.current')}</span>
                      )}
                    </div>
                    <p className="job-company">{localize(exp, 'company', language)}</p>
                    <p className="job-meta">{localize(exp, 'period', language)} · {localize(exp, 'type', language)}</p>
                    <p className="job-desc">{localize(exp, 'description', language)}</p>
                    <div className="job-tags">
                      {exp.technologies.map((tech) => (
                        <span className="job-tag" key={tech}>{tech}</span>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default ExperienceSection;
